import type { TranslationTree } from '../../types';

export const errors: TranslationTree = {
  errors: {
    // Allgemeine Fehler
    unknown: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    generic: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',

    // Netzwerkfehler
    network: {
      generic: 'Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung.',
      fetchFailed:
        'Keine Verbindung zum Server möglich. Bitte überprüfen Sie Ihre Internetverbindung.',
      requestFailed: 'Netzwerkanfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
      timeout: 'Die Anfrage hat zu lange gedauert. Bitte versuchen Sie es erneut.',
    },

    // API-Fehler
    api: {
      unknown: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
      badRequest:
        'Ungültige Anfrage. Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.',
      notFound: 'Die angeforderte Ressource wurde nicht gefunden.',
      conflict: 'Ein Konflikt ist aufgetreten. Die Ressource wurde möglicherweise geändert.',
      validationFailed: 'Validierung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingabe.',
      rateLimited: 'Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
      serverError: 'Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
      badGateway: 'Gateway-Fehler. Bitte versuchen Sie es später erneut.',
      unavailable: 'Dienst vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.',
      gatewayTimeout: 'Gateway-Zeitüberschreitung. Die Anfrage hat zu lange gedauert.',
      timeout: 'Anfrage-Zeitüberschreitung. Bitte versuchen Sie es erneut.',
      loadFailed: 'Laden der Daten fehlgeschlagen. Bitte versuchen Sie es erneut.',
      saveFailed: 'Speichern der Daten fehlgeschlagen. Bitte versuchen Sie es erneut.',
      deleteFailed: 'Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.',
      updateFailed: 'Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },

    // Authentifizierungsfehler
    auth: {
      unauthorized: 'Nicht autorisiert. Bitte melden Sie sich an.',
      forbidden: 'Zugriff verweigert. Sie haben keine Berechtigung.',
      authenticationFailed:
        'Authentifizierung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.',
      invalidCredentials: 'Ungültige E-Mail oder Passwort. Bitte versuchen Sie es erneut.',
      sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      permissionDenied: 'Sie haben keine Berechtigung für diese Aktion.',
    },

    // Validierungsfehler
    validation: {
      required: 'Dieses Feld ist erforderlich.',
      fieldRequired: 'Das Feld {{field}} ist erforderlich.',
      emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      emailRequired: 'E-Mail ist erforderlich.',
      passwordRequired: 'Passwort ist erforderlich.',
      passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
      passwordWeak:
        'Das Passwort ist zu schwach. Bitte verwenden Sie Groß-, Kleinbuchstaben und Zahlen.',
      tooShort: 'Dieser Wert ist zu kurz.',
      fieldTooShort: 'Das Feld {{field}} ist zu kurz.',
      tooLong: 'Dieser Wert ist zu lang.',
      fieldTooLong: 'Das Feld {{field}} ist zu lang.',
      invalidFormat: 'Ungültiges Format.',
      mustMatch: 'Werte stimmen nicht überein.',
    },

    // Kamerafehler
    camera: {
      generic: 'Kamerafehler aufgetreten. Bitte versuchen Sie es erneut.',
      notFound: 'Kein Kameragerät gefunden. Bitte überprüfen Sie Ihre Kameraverbindung.',
      permissionDenied: 'Kamerazugriff verweigert. Bitte erlauben Sie Kameraberechtigungen.',
      inUse: 'Kamera wird bereits von einer anderen Anwendung verwendet.',
      constraintFailed: 'Kameraeinschränkungen konnten nicht erfüllt werden.',
      accessFailed: 'Zugriff auf Kamera fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },

    // Datenfehler
    data: {
      parseFailed: 'Parsen der Daten fehlgeschlagen. Das Datenformat ist möglicherweise ungültig.',
      processingFailed: 'Verarbeitung der Daten fehlgeschlagen. Bitte versuchen Sie es erneut.',
      invalidFormat: 'Ungültiges Datenformat.',
    },

    // Fehlergrenzen (error boundaries)
    boundary: {
      title: 'Etwas ist schief gelaufen',
      description:
        'Die Anwendung hat einen unerwarteten Fehler festgestellt und muss neu geladen werden. Wir entschuldigen uns für die Unannehmlichkeiten.',
      reloadApp: 'Anwendung neu laden',
      tryAgain: 'Erneut versuchen',
      goBack: 'Zurück',
      goHome: 'Startseite',
      contactSupport: 'Support kontaktieren',
      persistsPrefix: 'Wenn dieses Problem weiterhin besteht, bitte',
      errorDetails: 'Fehlerdetails (nur Entwicklung):',
      componentStack: 'Komponenten-Stack',
      stackTrace: 'Stack-Trace',
      featureDescription:
        'Im Modul {{feature}} ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    },

    // Aktionsvorschläge
    actions: {
      retry: 'Bitte versuchen Sie es erneut.',
      pleaseLogin: 'Bitte melden Sie sich an, um fortzufahren.',
      contactAdmin: 'Bitte kontaktieren Sie Ihren Administrator.',
      checkUrl: 'Bitte überprüfen Sie die URL und versuchen Sie es erneut.',
      waitAndRetry: 'Bitte warten Sie einen Moment und versuchen Sie es erneut.',
      tryAgainLater: 'Bitte versuchen Sie es später erneut.',
      checkConnection: 'Bitte überprüfen Sie Ihre Internetverbindung.',
      checkCameraPermission:
        'Bitte überprüfen Sie die Kameraberechtigungen in Ihren Browsereinstellungen.',
      reload: 'Bitte laden Sie die Seite neu.',
      goBack: 'Bitte gehen Sie zurück und versuchen Sie es erneut.',
    },
  },
};
